import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';
import { Typography } from '@agria/theme/src/components/typography/Typography';
import { Divider } from '@agria/theme/src/components/divider/Divider';
import { SearchResultsListInterface } from './Search.interface';

const StyledResults = styled.div`
  ${({ theme: { colors, space } }) => css`
    display: grid;
    gap: ${space.xSmall};
    justify-items: start;
    color: ${colors.utilityText};

    a {
      text-decoration: none;
      scroll-margin-block: ${space.xxSmall};

      &:hover {
        text-decoration: underline;
      }
    }

    hr {
      width: 100%;
    }
  `};
`;

const SearchResultsList: FC<SearchResultsListInterface> = ({
  results,
  title,
}) => (
  <StyledResults>
    {title && (
      <>
        <Typography component="h4" variant="bodyMediumBold">
          {title}
        </Typography>
        <Divider />
      </>
    )}

    {results &&
      results.map((result) => (
        <Link to={result.url} key={result.id}>
          {result.label}
        </Link>
      ))}
  </StyledResults>
);

export { SearchResultsList };
